import React, { createContext, useContext, useState, useCallback, useMemo } from "react";
import SnackbarNotification, { SnackbarNotificationProps } from "./SnackbarNotification";

type SnackbarContextType = {
  showSnackbar: (props: SnackbarNotificationProps) => void;
};

const SnackbarContext = createContext<SnackbarContextType>({
  showSnackbar: () => {
    /* noop */
  },
});

export const SnackbarProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [snackbar, setSnackbar] = useState<SnackbarNotificationProps | null>(null);

  const showSnackbar = useCallback((props: SnackbarNotificationProps) => {
    setSnackbar(props);
  }, []);

  const handleClose = () => {
    setSnackbar(null);
  };

  const value = useMemo(() => ({ showSnackbar }), [showSnackbar]);

  return (
    <SnackbarContext.Provider value={value}>
      {children}
      {snackbar && <SnackbarNotification {...snackbar} onClose={handleClose} />}
    </SnackbarContext.Provider>
  );
};

// custom hook for easier consumption
export const useSnackbar = () => useContext(SnackbarContext);
